module.exports = __webpack_public_path__ + "img/徐镇镇.7d4f727a.png";